(() => {
  function comparisonCategory(product) {
    const type = String(product.type || product.product_type || '').trim().toLowerCase();
    const title = String(product.title || '');
    if (/chrysanordic/i.test(title) || /\b(?:dinnerware|tableware|drinkware|kitchenware|vases?|mugs?|teapots?|cutlery|bathrobes?|towels?|portable fans?|door locks?|smart door locks?)\b/i.test(type)) return null;
    if (type === 'cabinet hardware') {
      const tags = Array.isArray(product.tags) ? product.tags : String(product.tags || '').split(',');
      const hardwareTag = tags.some(tag => /^(?:cabinet handle|cabinet knob|cabinet door pull|drawer pull|drawer handle|drawer knob|handle pull)$/i.test(String(tag).trim()));
      if (/\b(?:locks?|hinges?|latches?)\b/i.test(title)) return null;
      return /\b(?:handles?|knobs?|pulls?)\b/i.test(title) || hardwareTag ? 'hardware' : null;
    }
    return /\b(?:lights?|lighting|lamps?|sconces?|pendants?|chandeliers?)\b/i.test(type + ' ' + title) ? 'lighting' : null;
  }
  function resolveVariant(variants, options) {
    return variants.find(v => v.available && v.options.length === options.length && v.options.every((value, i) => value === options[i]));
  }
  function optionAvailable(variants, selected, index, value) {
    return variants.some(v => v.available && v.options[index] === value && selected.slice(0, index).every((previous, i) => previous && v.options[i] === previous));
  }
  function sizeDiffers(a, b, indices) {
    return !!(a && b && indices.some(i => a.options[i] !== b.options[i]));
  }
  function selectionError(a, b, comparing, sizeIndices, info) {
    if (!a || (comparing && !b)) return 'Choose an available combination for each preview.';
    if (comparing && String(a.id) === String(b.id)) return 'Choose a different available combination for the second preview.';
    if (comparing && sizeDiffers(a, b, sizeIndices)) {
      if (!Number.isFinite(info.reference) || info.reference <= 0 || !info.label.trim() || !['cm', 'in', 'ft', 'm'].includes(info.units)) return 'Add a positive reference measurement, its units and what you measured.';
      if (info.chandelier && (!Number.isFinite(info.ceiling) || info.ceiling <= 0 || !info.placement.trim())) return 'Add a positive ceiling height and the intended chandelier placement.';
    }
    return '';
  }
  function defaultUnits(country) { return country === 'US' ? 'in' : 'cm'; }
  function toCm(value, units) { return value * ({ cm:1, in:2.54, ft:30.48, m:100 }[units]); }
  function fromCm(value, units) { return value / ({ cm:1, in:2.54, ft:30.48, m:100 }[units]); }
  function displayMeasurement(value) { return String(Number(value.toFixed(4))); }
  function sizeLabel(label, units) {
    const match = label.match(/^(?:(DIA|Diameter|Width|Height|Length)\s*)?(\d+(?:\.\d+)?)\s*(cm|mm|inches|inch|in|["″])(?:\s*\((\d+(?:\.\d+)?)\s*(cm|mm|inches|inch|in|["″])\))?$/i);
    if (!match) return label;
    const cm = (number, unit) => Number(number) * (/^mm$/i.test(unit) ? 0.1 : /^cm$/i.test(unit) ? 1 : 2.54);
    const value = cm(match[2], match[3]);
    if (!(value > 0)) return label;
    if (match[4] && Math.abs(cm(match[4], match[5]) - value) > Math.max(0.1, value * 0.02)) return label;
    const canonical = match[4] && /^cm$/i.test(match[5]) ? Number(match[4]) : value;
    return `${match[1] ? match[1] + ' ' : ''}${Number(fromCm(canonical, units).toFixed(2))} ${units}`;
  }
  function setup() {
    document.querySelectorAll('[data-room-preview]').forEach(dialog => {
      if (dialog.dataset.ready) return;
      dialog.dataset.ready = 'true';
      const form = dialog.querySelector('form');
      const variants = JSON.parse(dialog.querySelector('[data-room-variants]').textContent);
      const optionNames = JSON.parse(dialog.querySelector('[data-room-options]').textContent);
      const sizeIndices = optionNames.map((name, i) => /^(size|dimensions?|diameter|width|height|length)$/i.test(name.trim()) ? i : -1).filter(i => i >= 0);
      let currentUnits = defaultUnits(dialog.dataset.country);
      const mode = dialog.querySelector('[data-room-mode]');
      const comparison = dialog.querySelector('[data-room-comparison]');
      const measurementFields = dialog.querySelector('[data-room-scale]');
      const installationFields = dialog.querySelector('[data-room-installation]');
      const scaleHint = measurementFields.querySelector('.bks-room__hint');
      measurementFields.querySelector('legend').after(scaleHint);
      dialog.querySelector('.bks-room__details').before(measurementFields);
      const roomDetails = dialog.querySelector('.bks-room__details');
      roomDetails.querySelector('summary').firstChild.textContent = 'Room dimensions & additional details ';
      roomDetails.querySelector('.bks-room__hint').textContent = 'Optional: share your room’s overall dimensions and anything else we should consider.';
      const renderFirstName = dialog.querySelector('[data-room-first-name]');
      const renderEmail = dialog.querySelector('[data-room-email]');
      renderEmail.closest('label').firstChild.textContent = 'Email ';
      renderEmail.placeholder = 'Your email address';
      const intake = document.querySelector('[data-forms-id="forms-root-1211538"]');
      const nativeBlock = intake?.closest('.shopify-app-block');
      const intakeStage = document.createElement('section');
      intakeStage.className = 'bks-room__native-intake';
      intakeStage.hidden = true;
      intakeStage.style.padding = '0 24px 24px';
      const nativeGuardError = document.createElement('p');
      nativeGuardError.className = 'bks-room__error';
      nativeGuardError.setAttribute('role', 'alert');
      nativeGuardError.tabIndex = -1;
      const sendingStatus = document.createElement('p');
      sendingStatus.className = 'bks-room__hint';
      sendingStatus.setAttribute('role', 'status');
      sendingStatus.tabIndex = -1;
      form.querySelector('[data-room-fields]').before(nativeGuardError, sendingStatus);
      let protectedRequest = null, submissionPhase = 'idle', sendTimeout;
      let allowNativeSubmit = false, submitDispatched = false;
      const guardedRoots = new WeakSet(), observedReviewRoots = new WeakSet();
      if (nativeBlock) intakeStage.append(nativeBlock);
      dialog.append(intakeStage);
      const consent = document.createElement('label');
      consent.style.cssText = 'display:flex;align-items:flex-start;gap:10px;font-size:13px;line-height:1.45;font-weight:400;min-height:44px;margin-bottom:6px';
      const consentInput = document.createElement('input');
      consentInput.type = 'checkbox';
      consentInput.required = true;
      consentInput.style.cssText = 'width:20px;min-width:20px;height:20px;margin-top:3px';
      consentInput.dataset.roomProcessingConsent = '';
      const consentText = document.createElement('span');
      consentText.textContent = 'I agree to Baskoraa using my photos and details for my emailed preview. Anyone with a photo link can view it.';
      consent.append(consentInput, consentText);
      renderEmail.closest('label').after(consent);
      renderEmail.closest('label').querySelector('span').textContent = 'Required';
      dialog.querySelector('.bks-room__notice').textContent = 'Choose your pieces, add your room photo and details, then request your preview.';
      form.querySelector('[type="submit"]').textContent = 'Request my preview';
      function nativeRoot() { return intake?.querySelector('shopify-forms-embed')?.shadowRoot; }
      function nativeSet(element, value) {
        if (!element) throw new Error('A required Shopify form field is unavailable. Please try again shortly.');
        if (element.maxLength > 0 && value.length > element.maxLength) throw new Error('Your details exceed a Shopify form field limit. Shorten the notes and try again. No request has been submitted.');
        const proto = element.tagName === 'TEXTAREA' ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype;
        Object.getOwnPropertyDescriptor(proto, 'value').set.call(element, value);
        element.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
        element.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
        if (element.value !== value) throw new Error('Shopify could not retain your details. No request has been submitted. Please try again.');
      }
      function encodedNotes(request) {
        // Product URLs/options and photo files have dedicated native fields.
        return JSON.stringify({
          requestId: request.requestId,
          measurementUnits: request.measurementUnits,
          placement: request.placement,
          scaleReference: request.scaleReference,
          measurements: request.measurements.map(({ kind, value, units }) => ({ kind, value, units })),
          notes: request.notes,
          processingConsent: { accepted: request.processingConsent.accepted, recordedAt: request.processingConsent.recordedAt, version: 'public-link-render-v1' },
          testOnly: false
        });
      }
      function nativeNotes(request) {
        const notes = encodedNotes(request);
        // Shopify Forms enforces this limit even when textarea.maxLength is absent.
        if (notes.length > 1000) throw new Error(`Your room details exceed Shopify's 1,000-character limit by ${notes.length - 1000} characters. Shorten the placement, size-reference label or additional notes. Nothing has been truncated or submitted.`);
        return notes;
      }
      function productDetails(request) {
        return request.selections.map((v, index) => `${index ? 'Comparison' : 'Primary'}: ${v.productTitle}; https://baskoraa.com/products/${v.productHandle}?variant=${v.variantId}; variant_id=${v.variantId}; ${v.options.map(o => `${o.name}: ${o.value}`).join(', ')}`).join(' | ');
      }
      function validateGenerated(request, products, notes) {
        const fail = () => { throw new Error('Your request details could not be verified. Check your selections and details in this form, then try again. Nothing has been submitted.'); };
        if (!Array.isArray(request.selections) || request.selections.length !== (mode.value === 'single' ? 1 : 2)) fail();
        request.selections.forEach((piece, index) => {
          const variant = exactVariant(index);
          const secondProduct = index === 1 && productMode();
          const names = secondProduct ? otherProduct?.options.map(option => typeof option === 'string' ? option : option.name) : optionNames;
          const title = secondProduct ? otherProduct?.title : dialog.dataset.productTitle;
          const handle = secondProduct ? otherProduct?.handle : location.pathname.split('/').pop();
          if (!variant?.available || !/^\d+$/.test(piece.variantId) || String(variant.id) !== piece.variantId || !handle || piece.productHandle !== handle || piece.productTitle !== title || !Array.isArray(piece.options) || piece.options.length !== names?.length || piece.options.some((option, i) => option.name !== names[i] || option.value !== variant.options[i])) fail();
        });
        if (request.selections.length === 2 && request.selections[0].variantId === request.selections[1].variantId) fail();
        if (products !== productDetails(request) || !products.trim() || notes !== encodedNotes(request) || notes.length > 1000) fail();
        let payload;
        try { payload = JSON.parse(notes); } catch { fail(); }
        const consent = payload.processingConsent;
        if (!/^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(payload.requestId) || !['cm', 'in', 'ft', 'm'].includes(payload.measurementUnits) || payload.testOnly !== false || consent?.accepted !== true || consent.version !== 'public-link-render-v1' || typeof consent.recordedAt !== 'string' || !Number.isFinite(Date.parse(consent.recordedAt)) || new Date(consent.recordedAt).toISOString() !== consent.recordedAt || typeof payload.placement !== 'string' || typeof payload.notes !== 'string') fail();
        if (!Array.isArray(payload.measurements) || payload.measurements.some(item => !['width', 'length', 'height', 'reference', 'ceilingHeight'].includes(item.kind) || !Number.isFinite(item.value) || item.value <= 0 || item.units !== payload.measurementUnits)) fail();
        const scale = payload.scaleReference;
        if (scale !== null && (!scale || !Number.isFinite(scale.value) || scale.value <= 0 || scale.units !== payload.measurementUnits || typeof scale.measuredObject !== 'string' || !scale.measuredObject.trim() || (scale.ceilingHeight !== null && (!Number.isFinite(scale.ceilingHeight) || scale.ceilingHeight <= 0)))) fail();
        if (!measurementFields.disabled && scale === null) fail();
        if (ceiling.required && (!payload.placement.trim() || !payload.measurements.some(item => item.kind === 'ceilingHeight'))) fail();
      }
      function verifyProtectedRequest() {
        const record = protectedRequest;
        const root = nativeRoot();
        if (!record || root !== record.root || !intakeStage.hidden || form.hidden || record.nativeForm === form || !record.nativeForm.isConnected || root.querySelector('form') !== record.nativeForm) throw new Error('Request protection is unavailable.');
        record.fields.forEach(({ field, id, name, type, required, value }) => {
          if (root.getElementById(id) !== field || field.form !== record.nativeForm || field.getAttribute('name') !== name || field.type !== type || field.required !== required || field.matches(':disabled') || !field.readOnly || field.value !== value) throw new Error('Generated request details changed.');
          if (field.maxLength > 0 && value.length > field.maxLength) throw new Error('Generated field limit changed.');
        });
        validateGenerated(record.request, record.fields[0].value, record.fields[1].value);
      }
      function setSubmissionPhase(phase, message = '') {
        submissionPhase = phase;
        const locked = phase !== 'idle';
        fields.inert = locked;
        form.querySelector('[type="submit"]').disabled = locked;
        form.querySelector('[type="submit"]').textContent = phase === 'preparing' || phase === 'pending' ? 'Sending your request…' : 'Request my preview';
        form.querySelector('[data-room-reset]').disabled = locked;
        sendingStatus.textContent = message;
      }
      function unknownSubmission(message) {
        clearTimeout(sendTimeout); allowNativeSubmit = false;
        setSubmissionPhase('unknown', message || 'We could not confirm whether your request was received. Please do not send it again. Check your email or contact hello@baskoraa.com.');
        sendingStatus.focus();
      }
      function verifyNativeIntake() {
        verifyProtectedRequest();
        const record = protectedRequest;
        record.manual.forEach(({ field, value }) => {
          if (record.root.getElementById(field.id) !== field || field.form !== record.nativeForm || field.matches(':disabled') || field.value !== value) throw new Error('Your contact details could not be verified.');
        });
        record.photos.forEach(({ field, file }) => {
          if (record.root.getElementById(field.id) !== field || field.form !== record.nativeForm || field.matches(':disabled') || field.files.length !== (file ? 1 : 0) || (file && field.files[0] !== file)) throw new Error('Your photo selection could not be verified.');
        });
        const marketing = record.root.querySelector('[name="emailConsent"]');
        if (marketing?.checked) throw new Error('Marketing consent changed.');
      }
      function guardNativeSend(event) {
        try {
          if (event.type !== 'submit' || event.target !== protectedRequest?.nativeForm || submissionPhase !== 'preparing' || !allowNativeSubmit || submitDispatched) throw new Error('Submission is not authorized.');
          verifyNativeIntake();
          allowNativeSubmit = false;
          submitDispatched = true;
          setSubmissionPhase('pending', 'Sending your request…');
          sendTimeout = setTimeout(() => {
            if (submissionPhase === 'pending') unknownSubmission();
          }, 90000);
        } catch (failure) {
          event.preventDefault(); event.stopImmediatePropagation();
          nativeGuardError.textContent = failure.message;
        }
      }
      // Capture the native submit event before Shopify's own handler; never call private APIs.
      intakeStage.addEventListener('click', event => {
        if (event.composedPath().some(node => (node.tagName === 'BUTTON' || node.tagName === 'INPUT') && node.type === 'submit')) { event.preventDefault(); event.stopImmediatePropagation(); }
      }, true);
      function protectGenerated(root, request, productField, notesField) {
        protectedRequest = null;
        const nativeForm = root.querySelector('form');
        const fields = [productField, notesField];
        fields.forEach(field => {
          if (!field || root.getElementById(field.id) !== field || field.form !== nativeForm || field.matches(':disabled') || !(field.tagName === 'TEXTAREA' || (field.tagName === 'INPUT' && field.type === 'text'))) throw new Error('A generated request field is unavailable. No request has been submitted.');
          field.readOnly = false;
          if (!field.checkValidity()) throw new Error('A generated request field failed validation. No request has been submitted.');
        });
        validateGenerated(request, productField.value, notesField.value);
        const record = { root, nativeForm, request, fields: fields.map(field => ({ field, id: field.id, name: field.getAttribute('name'), type: field.type, required: field.required, value: field.value })) };
        fields.forEach(field => { field.readOnly = true; });
        if (!guardedRoots.has(root)) {
          root.addEventListener('submit', guardNativeSend, true);
          guardedRoots.add(root);
        }
        protectedRequest = record;
        nativeGuardError.textContent = '';
      }
      function observeNativeResult(root) {
        if (observedReviewRoots.has(root)) return;
        const observe = () => {
          if (!submitDispatched || !['pending', 'unknown'].includes(submissionPhase)) return;
          if (!root.querySelector('form') && root.textContent.includes('Preview request received')) {
            clearTimeout(sendTimeout);
            setSubmissionPhase('success');
            fields.hidden = true; summary.hidden = false;
            const header = form.querySelector('.bks-room__header');
            header.querySelector('div').hidden = true;
            header.style.justifyContent = 'flex-end';
            form.querySelectorAll(':scope > .bks-room__notice, :scope > .bks-room__product').forEach(element => { element.hidden = true; });
            nativeGuardError.textContent = ''; sendingStatus.textContent = '';
            nativeGuardError.hidden = true; sendingStatus.hidden = true;
            dialog.setAttribute('aria-labelledby', summary.querySelector('h3').id);
            dialog.scrollTop = 0; summary.focus();
            return;
          }
          const alerts = [...root.querySelectorAll('[role="alert"]')].map(element => element.textContent.trim()).filter(Boolean);
          const invalid = [...root.querySelectorAll('[aria-invalid="true"]')];
          if (alerts.length || invalid.length) {
            // A visible app error is not proof that a remote submission was never accepted.
            const detail = alerts.join(' ').slice(0, 500);
            unknownSubmission((detail ? detail + ' ' : 'Shopify reported a problem with this request. ') + 'Submission is not confirmed. Please do not resend; check your email or contact hello@baskoraa.com.');
          }
        };
        new MutationObserver(observe).observe(root, { childList:true, subtree:true, characterData:true, attributes:true, attributeFilter:['aria-invalid'] });
        observedReviewRoots.add(root);
      }
      async function prepareNative(request, email, photos) {
        protectedRequest = null;
        const root = nativeRoot();
        if (!root?.querySelector('form')) throw new Error('Shopify is still loading. Please try again shortly. Your request has not been submitted.');
        const photoFields = [...root.querySelectorAll('input[type="file"]')];
        if (photos.length > photoFields.length) throw new Error('The Shopify form does not have enough photo fields. Your request has not been submitted.');
        photoFields.forEach(field => {
          if (field.dataset.bksPhotoTracked) return;
          field.dataset.bksPhotoTracked = 'true';
          field.addEventListener('change', event => { if (event.isTrusted) nativePhotos = []; });
        });
        if (!root.bksPhotoTracked) {
          root.bksPhotoTracked = true;
          root.addEventListener('click', event => {
            if (event.isTrusted && event.composedPath().some(node => node.getAttribute?.('aria-label') === 'Clear file')) nativePhotos = [];
          }, true);
        }
        const productField = root.querySelector('[id="custom#product_url_and_selected_variant_id"]');
        const notesField = root.querySelector('[id="custom#placement_room_dimensions_cm_or_inches_and_notes"]');
        const products = productDetails(request);
        const notes = nativeNotes(request);
        const emailField = root.querySelector('[id="email"]');
        if (![emailField, productField, notesField].every(Boolean)) throw new Error('A required Shopify form field is unavailable. No photos have been uploaded and no request has been submitted.');
        const firstNameField = root.getElementById('first_name');
        if (!renderFirstName.value.trim() || !firstNameField) throw new Error('Enter your first name. Your request has not been sent.');
        nativeSet(firstNameField, renderFirstName.value);
        nativeSet(emailField, email);
        nativeSet(productField, products);
        nativeSet(notesField, notes);
        protectGenerated(root, request, productField, notesField);
        const marketing = root.querySelector('[name="emailConsent"]');
        if (marketing?.checked) marketing.click();
        const samePhotos = photos.length === nativePhotos.length && photos.every((file, index) => file === nativePhotos[index]);
        if (!samePhotos) {
          root.querySelectorAll('button[aria-label="Clear file"]').forEach(button => button.click());
          photos.forEach((file, index) => {
            const transfer = new DataTransfer();
            transfer.items.add(file);
            photoFields[index].files = transfer.files;
            photoFields[index].dispatchEvent(new Event('change', { bubbles: true, composed: true }));
          });
          nativePhotos = photos.slice();
        }
        const nativeForm = root.querySelector('form');
        const submitButton = nativeForm.querySelector('button[type="submit"]');
        if (nativeForm === form || !nativeForm.isConnected || typeof nativeForm.requestSubmit !== 'function' || !submitButton || submitButton.form !== nativeForm) throw new Error('The request form is unavailable. Nothing has been sent.');
        protectedRequest.manual = [firstNameField, emailField].map(field => ({ field, value: field.value }));
        protectedRequest.photos = photoFields.map((field, index) => ({ field, file: photos[index] || null }));
        observeNativeResult(root);
        // File change stores the FileList. Shopify's native submit handler owns and awaits uploads.
        // Yield once for native field updates; this is not an upload-ready timer.
        await new Promise(resolve => setTimeout(resolve, 0));
        verifyNativeIntake();
        if (submissionPhase !== 'preparing' || submitDispatched || submitButton.matches(':disabled') || submitButton.getAttribute('aria-disabled') === 'true') throw new Error('The request form is not ready. Nothing has been sent.');
        if (!nativeForm.checkValidity()) throw new Error('Check your request details. Nothing has been sent.');
        allowNativeSubmit = true;
        nativeForm.requestSubmit(submitButton);
        allowNativeSubmit = false;
        if (!submitDispatched) throw new Error(nativeGuardError.textContent || 'Shopify did not start the request. Nothing has been sent.');
      }
      const placement = dialog.querySelector('[data-room-placement]');
      const ceiling = dialog.querySelector('[data-room-ceiling]');
      const chandelier = /chandelier/i.test(dialog.dataset.productType + ' ' + dialog.dataset.productTitle);
      const comparableProduct = comparisonCategory({ type: dialog.dataset.productType, title: dialog.dataset.productTitle, tags: JSON.parse(dialog.dataset.productTags || '[]') });
      let nativePhotos = [];
      function comparisonModeLabel(names, variants, type, title) {
    const axes = names.filter((name, i) => new Set(variants.filter(v => v.available).map(v => v.options[i])).size > 1);
    if (axes.length === 1 && /^(colou?r|finish|lampshade colou?r|body colou?r|shade colou?r)$/i.test(axes[0].trim())) {
      const lamp = /\blamps?\b/i.test(type + ' ' + title) && !/\b(handle|knob|pull|hardware)s?\b/i.test(type);
      return lamp ? 'Compare two colours of this lamp' : 'Compare two colours of this product';
    }
    if (axes.length === 1 && /^(size|dimensions?|diameter|width|height|length)$/i.test(axes[0].trim())) return 'Compare two sizes of this product';
    return 'Same product, different colour or size';
  }
      const sameProductLabel = comparisonModeLabel(optionNames, variants, dialog.dataset.productType, dialog.dataset.productTitle);
      const canCompare = variants.filter(v => v.available).length > 1;
      mode.querySelector('[value="compare"]').textContent = sameProductLabel;
      let otherProduct = null, otherVariant = null, searchVersion = 0, searchTimer;
      const productMode = () => mode.value === 'product';
      if (comparableProduct) mode.add(new Option('Compare two different products', 'product'));
      mode.querySelector('[value="compare"]').disabled = !canCompare;
      if (!canCompare) mode.querySelector('[value="compare"]').remove();
      dialog.querySelector('[data-room-compare-note]').textContent = canCompare ? 'For a clearer comparison, change one option at a time. Light colour is illustrative, not an exact Kelvin simulation.' : 'This piece has only one available option.';
      const groups = ['a', 'b'].map(key => {
        const holder = dialog.querySelector(`[data-room-options-${key}]`);
        return optionNames.map((name, index) => {
          const label = document.createElement('label');
          label.append(document.createTextNode(name));
          const select = document.createElement('select');
          select.required = true;
          select.add(new Option(`Choose ${name.toLowerCase()}`, ''));
          [...new Set(variants.map(v => v.options[index]))].forEach(value => select.add(new Option(sizeIndices.includes(index) ? sizeLabel(value, currentUnits) : value, value)));
          label.append(select); holder.append(label);
          const choices = [...new Set(variants.filter(v => v.available).map(v => v.options[index]))];
          if (choices.length <= 1) { label.hidden = true; select.required = false; select.value = choices[0] || ''; }
          select.addEventListener('change', () => { refreshGroup(key === 'a' ? 0 : 1); updateMode(); updateProduct(); });
          return select;
        });
      });
      const unitSelects = [...dialog.querySelectorAll('[data-room-units]')];
      if (groups[0].every(select => select.parentElement.hidden)) dialog.querySelector('[data-room-options-a]').closest('fieldset').hidden = true;
      const measuredInputs = [...dialog.querySelectorAll('[data-room-reference], [data-room-ceiling], [data-room-detail]')];
      function resetUnits() {
        currentUnits = defaultUnits(dialog.dataset.country);
        unitSelects.forEach(select => { select.value = currentUnits; });
        refreshSizeLabels();
      }
      function refreshSizeLabels() {
        dialog.querySelectorAll('[data-room-unit-label]').forEach(label => { label.textContent = `(${currentUnits})`; });
        groups.forEach(group => group.forEach((select, i) => {
          if (sizeIndices.includes(i)) [...select.options].forEach(option => { if (option.value) option.textContent = sizeLabel(option.value, currentUnits); });
        }));
      }
      unitSelects.forEach(select => select.addEventListener('change', () => {
        const nextUnits = select.value;
        if (!['cm', 'in', 'ft', 'm'].includes(nextUnits)) return;
        // Preserve exactly what the customer typed; only change the selected unit and labels.
        currentUnits = nextUnits;
        unitSelects.forEach(other => { other.value = currentUnits; });
        refreshSizeLabels();
      }));
      resetUnits();
      const values = index => groups[index].map(select => select.value);
      const exactVariant = index => index === 1 && productMode() ? otherVariant : resolveVariant(variants, values(index));
      function refreshGroup(index) {
        const selections = values(index);
        groups[index].forEach((select, optionIndex) => {
          [...select.options].forEach(option => {
            if (!option.value) return;
            option.disabled = !optionAvailable(variants, selections, optionIndex, option.value);
          });
          if (select.selectedOptions[0]?.disabled) { select.value = ''; selections[optionIndex] = ''; }
        });
        const variant = exactVariant(index);
        const selectionStatus = dialog.querySelector(`[data-room-selection-${index === 0 ? 'a' : 'b'}]`);
        selectionStatus.textContent = variant ? '' : 'Choose an available combination.';
        selectionStatus.hidden = Boolean(variant);
      }
      function setGroup(index, variant) {
        groups[index].forEach((select, i) => { select.value = variant?.options[i] || ''; });
        refreshGroup(index);
      }
      function updateProduct() {
        const variant = exactVariant(0);
        const image = dialog.querySelector('[data-room-product-image]');
        const src = variant?.featured_image?.src || dialog.dataset.productImage;
        if (image && src && image.getAttribute('src') !== src) image.src = src;
        dialog.querySelector('[data-room-variant]').textContent = variant?.title && variant.title !== 'Default Title' ? variant.title : variant ? 'Standard option' : 'Choose an available combination';
      }
      function updateMode() {
        const comparing = (mode.value === 'compare' && canCompare) || productMode();
        comparison.hidden = !comparing;
        comparison.disabled = !comparing;
        const needsScale = comparing && (productMode() || comparableProduct === 'hardware' || sizeDiffers(exactVariant(0), exactVariant(1), sizeIndices));
        measurementFields.hidden = !needsScale;
        measurementFields.disabled = !needsScale;
        const hasChandelier = chandelier || (productMode() && /chandelier/i.test((otherProduct?.type || '') + ' ' + (otherProduct?.title || '')));
        installationFields.hidden = !hasChandelier;
        installationFields.disabled = !hasChandelier;
        ceiling.disabled = !hasChandelier;
        ceiling.required = hasChandelier;
        placement.required = hasChandelier;
        dialog.querySelector('[data-room-placement-required]').hidden = !hasChandelier;
        const note = dialog.querySelector('[data-room-compare-note]');
        note.hidden = mode.value === 'single' || productMode();
        note.textContent = productMode() ? '' : 'Change one option to compare the same piece in your room.';
        productSearch.hidden = !productMode();
        dialog.querySelector('[data-room-options-b]').hidden = productMode();
        groups[1].forEach(select => { select.disabled = productMode(); });
        comparison.querySelector('legend').textContent = productMode() ? 'Compare two different products' : sameProductLabel;
        comparison.querySelector('[data-room-selection-b]').hidden = productMode() ? false : Boolean(exactVariant(1));
      }
      const productSearch = document.createElement('div');
      productSearch.innerHTML = '<label>Find a product<input type="search" placeholder="Search lighting, handles or knobs…" autocomplete="off" data-room-product-search></label><p class="bks-room__hint" role="status" data-room-search-status></p><div data-room-search-results></div><div data-room-other-options></div>';
      comparison.append(productSearch);
      const searchInput = productSearch.querySelector('input');
      const searchStatus = productSearch.querySelector('[data-room-search-status]');
      const searchResults = productSearch.querySelector('[data-room-search-results]');
      const otherOptions = productSearch.querySelector('[data-room-other-options]');
      const originalNote = dialog.querySelector('[data-room-compare-note]');
      originalNote.hidden = mode.value === 'single';
      const comparisonText = () => {
        dialog.querySelector('[data-room-selection-b]').textContent = otherProduct && otherVariant ? `${otherProduct.title}${otherVariant.title === 'Default Title' ? '' : ' · ' + otherVariant.title}` : 'Choose another available product.';
      };
      async function chooseProduct(handle, version) {
        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}products/${encodeURIComponent(handle)}.js`);
          if (!response.ok) throw new Error();
          const product = await response.json();
          if (version !== searchVersion) return;
          if (!comparisonCategory(product)) { searchStatus.textContent = 'Choose lighting or a cabinet handle, knob or pull.'; return; }
          const available = product.variants.filter(v => v.available);
          if (!available.length || available.some(v => variants.some(current => String(current.id) === String(v.id)))) { searchStatus.textContent = 'Choose a different product with an available option.'; return; }
          otherProduct = product; otherVariant = available.length === 1 ? available[0] : null;
          otherOptions.replaceChildren(); searchResults.replaceChildren();
          const heading = document.createElement('strong'); heading.textContent = product.title; otherOptions.append(heading);
          const selectors = product.options.map((option, index) => {
            const label = document.createElement('label'); label.append(document.createTextNode(typeof option === 'string' ? option : option.name));
            const select = document.createElement('select'); select.add(new Option('Choose an option', ''));
            const values = [...new Set(available.map(v => v.options[index]))];
            values.forEach(value => select.add(new Option(value, value)));
            if (values.length === 1) { select.value = values[0]; label.hidden = true; }
            label.append(select); otherOptions.append(label); return select;
          });
          const refresh = () => {
            selectors.forEach((select, index) => {
              [...select.options].forEach(option => { if (option.value) option.disabled = !optionAvailable(available, selectors.map(s => s.value), index, option.value); });
              if (select.selectedOptions[0]?.disabled) select.value = '';
            });
            otherVariant = resolveVariant(available, selectors.map(s => s.value)); comparisonText(); updateMode(); invalidate(); updateBudget();
          };
          selectors.forEach(select => select.addEventListener('change', refresh)); refresh();
          searchStatus.textContent = 'Product selected. Search again to change it.';
        } catch { if (version === searchVersion) searchStatus.textContent = 'Unable to load this product. Please try again.'; }
      }
      searchInput.addEventListener('input', () => {
        clearTimeout(searchTimer); const version = ++searchVersion;
        otherProduct = null; otherVariant = null; otherOptions.replaceChildren(); searchResults.replaceChildren(); comparisonText(); invalidate();
        const query = searchInput.value.trim();
        if (query.length < 2) { searchStatus.textContent = 'Enter at least two characters.'; return; }
        searchStatus.textContent = 'Searching…';
        searchTimer = setTimeout(async () => {
          try {
            const params = new URLSearchParams({ q: query, 'resources[type]': 'product', 'resources[limit]': '8', 'resources[options][unavailable_products]': 'hide' });
            const response = await fetch(`${window.Shopify?.routes?.root || '/'}search/suggest.json?${params}`);
            if (!response.ok) throw new Error();
            const data = await response.json(); if (version !== searchVersion) return;
            const products = data.resources.results.products.filter(p => p.handle !== location.pathname.split('/').pop() && comparisonCategory(p));
            searchStatus.textContent = products.length ? 'Choose a product below.' : 'No matching lighting or cabinet hardware. Try another name.';
            products.forEach(product => {
              const button = document.createElement('button'); button.type = 'button'; button.textContent = product.title;
              button.style.cssText = 'display:block;width:100%;text-align:left;padding:12px;margin-bottom:8px;border:1px solid #b8a899;border-radius:6px;background:#fffdf8;color:inherit';
              button.addEventListener('click', () => { searchStatus.textContent = 'Loading product…'; chooseProduct(product.handle, ++searchVersion); }); searchResults.append(button);
            });
          } catch { if (version === searchVersion) searchStatus.textContent = 'Search is unavailable. Please try again.'; }
        }, 300);
      });
      mode.addEventListener('change', () => {
        if (mode.value === 'compare') { groups[1].forEach((select, i) => { select.value = groups[0][i].value; }); refreshGroup(1); }
        updateMode();
        if (productMode()) comparisonText();
      });
      updateMode();
      const inputs = [...dialog.querySelectorAll('[data-room-photo]')];
      const urls = new Map();
      const summary = dialog.querySelector('[data-room-summary]');
      const error = dialog.querySelector('[data-room-error]');
      let opener, timer, oldOverflow, selected;
      const fields = dialog.querySelector('[data-room-fields]');
      const invalidate = () => { if (submissionPhase !== 'idle') return; protectedRequest = null; delete dialog.dataset.previewRequest; summary.hidden = true; fields.hidden = false; };
      const fieldErrors = new Map();
      function showFieldError(field, message) {
        let notice = fieldErrors.get(field);
        if (!notice) {
          notice = document.createElement('p');
          notice.className = 'bks-room__error'; notice.setAttribute('role', 'alert');
          notice.id = dialog.id + '-field-error-' + fieldErrors.size;
          field.closest('label').after(notice);
          field.setAttribute('aria-describedby', [field.getAttribute('aria-describedby'), notice.id].filter(Boolean).join(' '));
          fieldErrors.set(field, notice);
        }
        notice.textContent = message; field.setAttribute('aria-invalid', 'true');
        if (field.closest('details')) field.closest('details').open = true;
        field.focus();
      }
      function clearFieldErrors() {
        fieldErrors.forEach((notice, field) => { notice.textContent = ''; field.removeAttribute('aria-invalid'); });
      }
      function detailRequest(requestId, recordedAt) {
        const reference = dialog.querySelector('[data-room-reference]');
        return {
          requestId,
          notes: dialog.querySelector('[data-room-notes]').value.trim(),
          processingConsent: { accepted: true, recordedAt },
          measurementUnits: currentUnits,
          scaleReference: !measurementFields.disabled ? { value: reference.valueAsNumber, units: currentUnits, measuredObject: dialog.querySelector('[data-room-reference-label]').value.trim(), ceilingHeight: !ceiling.disabled ? ceiling.valueAsNumber : null } : null,
          measurements: measuredInputs.filter(input => Number.isFinite(input.valueAsNumber) && !input.matches(':disabled')).map(input => ({
            kind: input.dataset.roomDetail || (input.hasAttribute('data-room-reference') ? 'reference' : 'ceilingHeight'),
            value: input.valueAsNumber, units: currentUnits,
            valueCm: toCm(input.valueAsNumber, currentUnits)
          })),
          placement: placement.value.trim(), testOnly: false
        };
      }
      function updateBudget() {
        // Fixed-length placeholders reserve the UUID and ISO timestamp without creating a request.
        const remaining = 1000 - encodedNotes(detailRequest('00000000-0000-0000-0000-000000000000', '2000-01-01T00:00:00.000Z')).length;
        const budget = dialog.querySelector('[data-room-budget]');
        budget.textContent = remaining < 0 ? `Room details are ${-remaining} characters over the limit. Shorten your placement, measured-feature description or notes before sending.` : `${remaining} characters remaining for room details and notes. This shared limit updates as you fill in the form.`;
        budget.className = remaining < 0 ? 'bks-room__error' : 'bks-room__hint';
        return remaining;
      }
      function syncVariant() {
        if (submissionPhase !== 'idle') return;
        const scope = document.querySelector('.product-info');
        const id = scope?.querySelector('form[action*="/cart/add"] [name="id"]')?.value || new URLSearchParams(location.search).get('variant') || dialog.dataset.initialVariant;
        const variant = variants.find(v => String(v.id) === String(id)) || variants.find(v => String(v.id) === dialog.dataset.initialVariant);
        if (selected?.id !== variant?.id) {
          invalidate(); setGroup(0, variant); setGroup(1, variant); selected = variant;
          updateMode(); updateProduct();
        }
      }

      function clearPhoto(input) {
        if (urls.has(input)) URL.revokeObjectURL(urls.get(input));
        urls.delete(input);
        input.value = '';
        input.removeAttribute('aria-invalid');
        const box = input.closest('.bks-room__photo');
        box.querySelector('img').removeAttribute('src');
        box.querySelector('[data-photo-preview]').hidden = true;
        box.querySelector('[data-photo-error]').textContent = '';
        invalidate();
      }
      function reset() {
        if (submissionPhase !== 'idle') return;
        protectedRequest = null;
        nativeGuardError.textContent = '';
        inputs.forEach(clearPhoto);
        intakeStage.hidden = true; form.hidden = false;
        const root = nativeRoot();
        root?.querySelectorAll('button[aria-label="Clear file"]').forEach(button => button.click());
        nativePhotos = [];
        root?.querySelectorAll('input:not([type="file"]):not([type="checkbox"]):not([id="first_name"]):not([id="last_name"]),textarea:not([name="h-captcha-response"])').forEach(input => nativeSet(input, ''));
        form.reset();
        ++searchVersion; clearTimeout(searchTimer); otherProduct = null; otherVariant = null;
        searchResults.replaceChildren(); otherOptions.replaceChildren(); searchStatus.textContent = ''; comparisonText();
        resetUnits();
        selected = undefined;
        syncVariant();
        updateMode();
        delete dialog.dataset.previewRequest;
        error.textContent = '';
        form.querySelectorAll('[aria-invalid]').forEach(el => el.removeAttribute('aria-invalid'));
        invalidate();
        clearFieldErrors(); updateBudget();
      }
      inputs.forEach(input => {
        const box = input.closest('.bks-room__photo');
        box.querySelector('[data-photo-remove]').addEventListener('click', () => { clearPhoto(input); input.focus(); });
        input.addEventListener('change', () => {
          const file = input.files[0];
          clearPhoto(input);
          if (!file) return;
          let message = '';
          if (!['image/jpeg','image/png','image/webp'].includes(file.type)) message = 'Choose a JPEG, PNG or WebP image.';
          else if (!file.size || file.size > 10 * 1024 * 1024) message = 'Choose a photo smaller than 10 MB (not an empty file).';
          if (message) { box.querySelector('[data-photo-error]').textContent = message; input.setAttribute('aria-invalid','true'); return; }
          const transfer = new DataTransfer(); transfer.items.add(file); input.files = transfer.files;
          const url = URL.createObjectURL(file); urls.set(input, url);
          const img = box.querySelector('img');
          img.onerror = () => { if (urls.get(input) !== url) return; clearPhoto(input); box.querySelector('[data-photo-error]').textContent = 'This image could not be read. Please choose another photo.'; input.setAttribute('aria-invalid','true'); };
          img.src = url;
          box.querySelector('[data-photo-preview]').hidden = false;
        });
      });
      const lowerCard = document.querySelector('.baskoraa-space__copy') || document.querySelector('.baskoraa-space');
      const primaryOpener = document.querySelector(`.bks-preview-card [data-room-open="${dialog.id}"]`);
      if (lowerCard && primaryOpener && !lowerCard.querySelector('[data-room-open]')) lowerCard.append(primaryOpener.cloneNode(true));
      document.querySelectorAll(`[data-room-open="${dialog.id}"]`).forEach(button => button.addEventListener('click', () => {
        opener = button;
        syncVariant();
        oldOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        dialog.showModal();
        dialog.scrollTop = 0;
        if (submissionPhase === 'success') summary.focus();
        else dialog.querySelector('h2').focus();
        updateBudget();
        timer = setInterval(syncVariant, 250);
      }));
      function requestClose() {
        if (submissionPhase !== 'idle') { dialog.close(); return; }
        const hasDetails = urls.size || mode.value !== 'single' || groups[0].some((select, index) => select.value !== selected?.options[index]) || placement.value.trim() || renderFirstName.value.trim() || renderEmail.value.trim() || consentInput.checked || dialog.querySelector('[data-room-notes]').value.trim() || measuredInputs.some(input => input.value);
        const completed = !intakeStage.hidden && !nativeRoot()?.querySelector('form');
        if (!completed && hasDetails && !window.confirm('Discard this preview request? Your photos and details will be cleared. Choose Cancel to keep editing.')) return;
        dialog.close();
      }
      dialog.querySelectorAll('[data-room-close]').forEach(button => button.addEventListener('click', requestClose));
      dialog.addEventListener('cancel', event => { event.preventDefault(); requestClose(); });
      dialog.addEventListener('close', () => { clearInterval(timer); reset(); document.body.style.overflow = oldOverflow || ''; opener?.focus(); });
      dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab' || !intakeStage.hidden) return;
        const focusable = [...dialog.querySelectorAll('button,input,select,textarea,a[href],summary')].filter(el => !el.disabled && !el.closest('[inert]') && el.getClientRects().length);
        const first = focusable[0], last = focusable[focusable.length - 1];
        if (event.shiftKey && (document.activeElement === first || !focusable.includes(document.activeElement))) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      });
      dialog.querySelector('[data-room-reset]').addEventListener('click', () => { reset(); inputs[0].focus(); });
      dialog.querySelector('[data-room-edit]')?.addEventListener('click', () => { invalidate(); inputs[0].focus(); });
      form.addEventListener('input', invalidate);
      form.addEventListener('input', () => { clearFieldErrors(); updateBudget(); });
      form.addEventListener('change', () => { clearFieldErrors(); updateBudget(); });
      form.addEventListener('submit', async event => {
        if (event.target !== form) return;
        event.preventDefault();
        if (submissionPhase !== 'idle' || submitDispatched) return;
        syncVariant(); error.textContent = ''; invalidate();
        const a = exactVariant(0), b = mode.value !== 'single' ? exactVariant(1) : null;
        const reference = dialog.querySelector('[data-room-reference]');
        const referenceLabel = dialog.querySelector('[data-room-reference-label]');
        const units = currentUnits;
        clearFieldErrors();
        if (!measurementFields.disabled) {
          if (!referenceLabel.value.trim()) { showFieldError(referenceLabel, 'Describe the feature you measured, such as the table width.'); return; }
          if (!reference.validity.valid) { showFieldError(reference, 'Enter a positive reference measurement.'); return; }
        }
        if (ceiling.required && !ceiling.validity.valid) { showFieldError(ceiling, 'Enter the ceiling height for this chandelier.'); return; }
        if (placement.required && !placement.value.trim()) { showFieldError(placement, 'Tell us where you would place the chandelier.'); return; }
        if (updateBudget() < 0) { showFieldError(dialog.querySelector('[data-room-notes]'), 'Shorten the room details to fit the shared limit shown below. Nothing has been truncated or submitted.'); return; }
        const crossError = productMode() && (!otherProduct || !b) ? 'Choose another available product and its options.' : productMode() && (!Number.isFinite(reference.valueAsNumber) || reference.valueAsNumber <= 0 || !referenceLabel.value.trim()) ? 'Add a positive reference measurement and tell us what you measured.' : '';
        const message = crossError || selectionError(a, b, mode.value !== 'single', productMode() ? [] : sizeIndices, {
          reference: reference.valueAsNumber, label: referenceLabel.value, units,
          chandelier, ceiling: ceiling.valueAsNumber, placement: placement.value
        });
        if (message) { error.textContent = message; error.setAttribute('tabindex', '-1'); error.focus(); return; }
        if (!urls.has(inputs[0])) { error.textContent = 'Please add your first room photo.'; inputs[0].setAttribute('aria-invalid','true'); inputs[0].focus(); return; }
        const invalid = [...form.elements].find(el => el.willValidate && !el.validity.valid);
        if (invalid?.closest('details')) invalid.closest('details').open = true;
        if (!renderFirstName.value.trim()) { showFieldError(renderFirstName, 'Enter your first name.'); return; }
        if (!form.reportValidity()) return;
        const detail = v => `${v === b && productMode() ? otherProduct.title : dialog.dataset.productTitle}${v.title === 'Default Title' ? '' : ' · ' + v.title} (variant ${v.id})`;
        const comparisonDetail = b ? ` Comparing ${detail(a)} and ${detail(b)}.` : ` Selected ${detail(a)}.`;
        const request = {
          ...detailRequest(crypto.randomUUID(), new Date().toISOString()),
          processingConsent: { accepted: consentInput.checked, recordedAt: new Date().toISOString(), wording: consentText.textContent },
          product: dialog.dataset.productTitle,
          selections: [a, b].filter(Boolean).map(v => ({ productTitle: v === b && productMode() ? otherProduct.title : dialog.dataset.productTitle, productHandle: v === b && productMode() ? otherProduct.handle : location.pathname.split('/').pop(), variantId: String(v.id), options: (v === b && productMode() ? otherProduct.options.map(o => typeof o === 'string' ? o : o.name) : optionNames).map((name, i) => ({ name, value: v.options[i] })) })),
        };
        try {
          setSubmissionPhase('preparing', 'Sending your request…');
          await prepareNative(request, renderEmail.value.trim(), inputs.filter(input => urls.has(input)).map(input => input.files[0]));
        } catch (failure) {
          allowNativeSubmit = false;
          if (submitDispatched) { unknownSubmission(); return; }
          setSubmissionPhase('idle');
          error.textContent = failure.message;
          error.tabIndex = -1;
          error.focus();
        }
      });
      window.addEventListener('pagehide', () => { clearInterval(timer); reset(); });
    });
  }
  setup();
  document.addEventListener('shopify:section:load', setup);
})();




